import { createContext, useContext } from 'react'

export interface SegmentedControlContextProps {
  value: string
  onChange: (value: string) => void
  setActiveRef: (element: HTMLButtonElement | null) => void
}

const SegmentedControlContext = createContext<SegmentedControlContextProps | null>(null)

export const useSegmentedControl = (): SegmentedControlContextProps => {
  const context = useContext(SegmentedControlContext)
  if (!context) {
    throw new Error('useSegmentedControl must be used within a SegmentedControl')
  }
  return context
}

export default SegmentedControlContext
